import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Button, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { useTheme } from '../../../styles/theme';
import { Code } from '@common/Code';

export const ScrollablePre = styled.pre<{ largeFont?: boolean }>`
  overflow-x: auto;
  overflow-y: auto;
  font-size: ${({ largeFont }) => (largeFont ? '16px' : 'initial')};

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &:hover,
  &:focus,
  &:active {
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.scrollbar.thumb};
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
      background-color: ${({ theme }) => theme.scrollbar.track};
    }
  }
`;

interface Props {
  error: string | null;
  setError: React.Dispatch<string | null>;
}

export const ViewError: React.FC<Props> = ({ error, setError }) => {
  const theme = useTheme();

  const errorData = useMemo(() => {
    try {
      return JSON.parse(error || '');
    } catch (err) {
      return error;
    }
  }, [error]);

  return (
    <Modal
      open={Boolean(error)}
      setOpen={() => setError(null)}
      header='Error Details'
      background={theme.telnyx.yellow}
      icon={<ErrorOutline />}
      body={
        <ScrollablePre largeFont>
          <Code code={errorData || 'There was no error information found'} language='json' />
        </ScrollablePre>
      }
      actions={
        <Stack direction='row' spacing={1}>
          <Button small onClick={() => setError(null)}>
            Close
          </Button>
        </Stack>
      }
    />
  );
};
